module.exports = __webpack_public_path__ + "img/DE05778.e33ba296.png";